import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actionCreators from '../../../../modules/actions/index';
import MapEthnicity from '../../../../components/OrganizationSetup/MapEthnicity/MapEthnicity';

class MapEthnicitySetup extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.resetMapEthnicityStep();
  }

  handleFileUpload = (columns, data, file) => {
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip performance mapping');
  }

  render() {
    return (<div className="mb20 mt60">
    <MapEthnicity 
      onProcessedFileUploadData={this.handleFileUpload}
      onMapGenderMatchColumn={this.handleMatchColumn}
      onSkipEthnicityMapping={this.handleSkipMapping}
      {...this.props}/>
    </div>);
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapEthnicity : state.mapping.ethnicity
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapEthnicityStep: () => dispatch(actionCreators.resetMapEthnicityStep()),
    nextStep: () => dispatch(actionCreators.mapEthnicityNextStep()),
    goBack : () => dispatch(actionCreators.mapEthnicityGoBack()),
    saveAllEthnicityMapping : (o,s) => dispatch(actionCreators.saveAllEthnicityMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapEthnicityUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapEthnicityMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapEthnicitySetup);